import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";

import { getVSIFileIcon } from "file-extension-icon-js";

import { inforPasta } from "../../services/http/pastaService";

import {
  registrarDownloadPasta,
  registrarVisualizacaoPasta,
  registrarVisualizacaoArquivo,
} from "../../services/http/dashboardService";

import {
  detalhesArquivo,
  inforArquivo,
} from "../../services/http/arquivoServico";

import { listarPermissoes } from "../../services/http/usuariosService";

import { Modal } from "antd";

import IconeArquivos from "../IconeArquivos";

import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";

import "./styles.scss";
import { CloseOutlined } from "@mui/icons-material";
import { getIconesExtensao } from "../../services/utils";
import lang from "../../assets/idioma/idiomas";

const ModalInfo = ({
  id,
  tipo,
  closeModal,
  openModal,
  handleRemoverFavorito,
  favoritar,
  favoritarDesfavoritar,
}) => {
  const [permissoes, setPermissoes] = useState([]);
  const [infoFavoritar, setInfoFavoritar] = useState({
    id: id,
    tipo: tipo.toLocaleLowerCase(),
  });
  const [infoPermissoes, setInfoPermissoes] = useState([{}]);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (tipo.toLocaleLowerCase() == "arquivo") {
      buscarDetalhesArquivo();
    } else {
      buscarDetalhesPasta();
    }
  }, [id, tipo, favoritarDesfavoritar]);

  const buscarDetalhesPasta = () => {
    trackPromise(
      inforPasta(id)
        .then((res) => {
          if (!res.fail && res.data) {
            setInfo(res.data);
            registrarVisualizacaoPastas(res.data.id);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const registrarVisualizacaoPastas = (idPasta) => {
    trackPromise(
      registrarVisualizacaoPasta(idPasta)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const buscarDetalhesArquivo = () => {
    trackPromise(
      inforArquivo(id)
        .then((res) => {
          if (!res.fail && res.data) {
            setInfo(res.data);
            registrarVisualizacaoArquivo(id);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const formatarData = (value) => {
    var data = new Date(value);
    return `${data.toLocaleDateString()} ${data.toLocaleTimeString()}`;
  };

  const arquivoVisualizar = () => {
    if (info != null) {
      const extensao = info.extensao ?? info.nome.split(".")[1];

      let nomeArquivo =
        !info.nome.includes(".") && extensao != null
          ? `${info.nome}.${extensao}`
          : info.nome;
      registrarVisualizacaoArquivo(id);
      return (
        <div className="info-icone-pasta">
          <img src={getIconesExtensao(extensao)} />
        </div>
      );
    }
  };

  return (
    <div>
      <Modal
        visible={openModal}
        className="modal-info"
        closable={false}
        destroyOnClose={true}
        footer={[]}
      >
        <CloseOutlined onClick={closeModal} className="custom-close-icon" />
        {info != null && tipo.toLocaleLowerCase() == "arquivo" ? (
          <div className="row">
            <div className="fundoModalInfo col-md-5 ">
              {info.ehFavorito ? (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    handleRemoverFavorito(infoFavoritar);
                  }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                    fill="#828282"
                  />
                </svg>
              ) : (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    favoritar(infoFavoritar);
                  }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                    fill="#aaa"
                  />
                </svg>
              )}
              {info != null && info.urlPreview != null ? (
                <div className="info-icone-imgs">
                  <img src={info.urlPreview} />
                </div>
              ) : (
                arquivoVisualizar()
              )}
            </div>
            <div className="container-info col-md-7 p-0">
              <div className="info-pasta" style={{ paddingBottom: "1rem" }}>
                <div className="info-group-info">
                  <span className="label-titulo">Nome:</span>
                  <span className="label-info"> {info.nome}</span>
                </div>

                <div className="info-group">
                  <div className="info-group-info">
                    <span className="label-titulo">Tamanho:</span>
                    <span className="label-info">{info.tamanho}</span>
                  </div>

                  <div
                    className="info-group-info"
                    style={{ marginLeft: "4rem" }}
                  >
                    <span className="label-titulo">Dimensões:</span>
                    <span className="label-info">
                      {info.dimensoes ==
                        "Erro ao obter dimensões: Parameter is not valid." ||
                      info.dimensoes == null ||
                      info.dimensoes == undefined
                        ? "Não informado"
                        : info.dimensoes}
                    </span>
                  </div>
                  <div
                    className="info-group-info"
                    style={{ marginLeft: "4rem" }}
                  >
                    <span className="label-titulo">Tipo do Arquivo:</span>
                    <span className="label-info">{info.extensao}</span>
                  </div>
                </div>

                <div className="info-group">
                  <div className="info-group-info">
                    <span className="label-titulo">Autor:</span>
                    <span className="label-info">{info.autor}</span>
                  </div>
                </div>

                <div className="info-group">
                  <div className="info-group">
                    <div className="info-group-info">
                      <span className="label-titulo">Data de inclusão:</span>
                      <span className="label-info">{info.dataCriacao}</span>
                    </div>

                    <div
                      className="info-group-info"
                      style={{ marginLeft: "4rem" }}
                    >
                      {info.dataAlteracao && (
                        <span className="label-titulo">Última alteração:</span>
                      )}
                      <span className="label-info">{info.dataAlteracao}</span>
                    </div>

                    {info.descricao && (
                      <div
                        className="info-group-info"
                        style={{ marginLeft: "4rem" }}
                      >
                        <span className="label-titulo">Descrição:</span>
                        <span className="label-info">{info.descricao}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="info-group">
                  <div className="info-group-permissoes">
                    <span className="label-titulo">{lang.Permissoes}:</span>
                    <div
                      className="label-info"
                      style={{
                        paddingRight: "2rem",
                        maxHeight: 200,
                        overflowY: "auto",
                      }}
                    >
                      {info.permissoes?.map((item) => {
                        return (
                          <div key={item}>
                            <span> {item} </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="info-group-info posicaoCompartilhado">
                    {info?.compartilhado?.length > 0 && (
                      <span className="label-titulo">
                        {lang.Compartilhado_com}:
                      </span>
                    )}
                    <div
                      className="label-info"
                      style={{
                        paddingRight: "10rem",
                        maxHeight: 200,
                        overflowY: "auto",
                      }}
                    >
                      {info.compartilhado?.map((item) => {
                        return (
                          <div key={item}>
                            <span> {item} </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {info != null && tipo.toLocaleLowerCase() == "pasta" ? (
          <div className="row">
            <div className="fundoModalInfo col-md-5 ">
              {info.ehFavorito ? (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    handleRemoverFavorito(infoFavoritar);
                  }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                    fill="#828282"
                  />
                </svg>
              ) : (
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    favoritar(infoFavoritar);
                  }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                    fill="#aaa"
                  />
                </svg>
              )}

              <div className="info-icone-pasta">
                <img src={infoPastaSvg} />
              </div>
            </div>
            <div className="container-info col-md-7 p-0">
              <div className="info-pasta">
                <div className="info-group-info">
                  <span className="label-titulo">{lang.Nome}:</span>
                  <span className="label-info">{info.nome}</span>
                </div>

                <div className="info-group-info">
                  <span className="label-titulo">{lang.Tamanho_total}:</span>
                  <span className="label-info">{info.tamanhoTotal}</span>
                </div>

                <div className="info-group-info">
                  <span className="label-titulo">{lang.Contem}:</span>
                  <span className="label-info">
                    {info.quantidadePastas} {lang.Pastas}
                  </span>
                  <span className="label-info">
                    {info.quantidadeArquivos} {lang.Arquivos}
                  </span>
                </div>

                <div className="info-group">
                  <div className="info-group-info">
                    <span className="label-titulo">{lang.Autor}:</span>
                    <span className="label-info">{info.autor}</span>
                  </div>

                  <div
                    className="info-group-info"
                    style={{ paddingLeft: "244px" }}
                  >
                    <span className="label-titulo">
                      {lang.Data_de_criacao}:
                    </span>
                    <span className="label-info">{info.dataCriacao}</span>
                  </div>
                </div>

                <div className="info-group">
                  <div className="info-group">
                    <div className="info-group-info">
                      <span className="label-titulo">Data de inclusão:</span>
                      <span className="label-info">{info.dataCriacao}</span>
                    </div>

                    <div
                      className="info-group-info"
                      style={{ marginLeft: "4rem" }}
                    >
                      {info.dataAlteracao && (
                        <span className="label-titulo">Última alteração:</span>
                      )}
                      <span className="label-info">{info.dataAlteracao}</span>
                    </div>

                    {info.descricao && (
                      <div
                        className="info-group-info"
                        style={{ marginLeft: "4rem" }}
                      >
                        <span className="label-titulo">Descrição:</span>
                        <span className="label-info">{info.descricao}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="info-group">
                  <div className="info-group-permissoes">
                    <span className="label-titulo">{lang.Permissoes}:</span>
                    <div
                      className="label-info"
                      style={{
                        paddingRight: "2rem",
                        maxHeight: 200,
                        overflowY: "auto",
                      }}
                    >
                      {info.permissoes?.map((item) => {
                        return (
                          <div key={item}>
                            <span> {item} </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="info-group-info posicaoCompartilhado">
                    {info?.compartilhado?.length > 0 && (
                      <span className="label-titulo">
                        {lang.Compartilhado_com}:
                      </span>
                    )}
                    <div
                      className="label-info"
                      style={{
                        paddingRight: "10rem",
                        maxHeight: 200,
                        overflowY: "auto",
                      }}
                    >
                      {info.compartilhado?.map((item) => {
                        return (
                          <div key={item}>
                            <span> {item} </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default ModalInfo;
